import { Form } from "react-router";
import { JoinButton } from "~/components/molecules/JoinButton";
import { useRouteData, RouteIds } from "~/lib/routing";
import { captureScrollPosition, getAuthUrls } from "~/lib/utils";

export default function LoginLink({ returnTo }: { returnTo?: string }) {
    const { authenticated, FEATURES } = useRouteData(RouteIds.ROOT);
    const { login, logout, signUp } = getAuthUrls({ returnTo });

    if (!FEATURES.BETAExperience) return null;

    return (
        <div className="mt-3 flex w-full justify-end pr-4">
            <Form action={authenticated ? logout : login} method="post" className="mx-3">
                <button className="font-bold text-white" onClick={captureScrollPosition}>
                    {authenticated ? "Log Out" : "Log In"}
                </button>
            </Form>
            {!authenticated && (
                <Form action={signUp} method="post" className="mx-3">
                    <JoinButton
                        data-testid="LoginLink"
                        size="lg"
                        buttonStyle="secondary"
                        returnTo={returnTo}
                    />
                </Form>
            )}
        </div>
    );
}
